export const HOME = {
  emergentLink: "home-emergent-link",
};
